import * as React from 'react';
import { SVGProps } from 'react';

const IconSpeedSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M4.5 13.77c0-3.952 3.31-7.24 7.5-7.24 4.19 0 7.5 3.288 7.5 7.24 0 1.734-.631 3.33-1.695 4.582L19.703 20A9.6 9.6 0 0 0 22 13.77C22 8.325 17.475 4 12 4S2 8.326 2 13.77A9.6 9.6 0 0 0 4.298 20l1.896-1.648A7.053 7.053 0 0 1 4.5 13.77Z" />
    <path d="M11.165 15.813c.768.542 1.811.371 2.33-.381.518-.752 2.52-6.657 2.52-6.657s-4.784 3.942-5.302 4.694c-.519.752-.316 1.802.452 2.344Z" />
  </svg>
);
export default IconSpeedSizeM;
